/* Pili Car Detailing — theme scripts (Shopify Cart AJAX API) */
(function () {
  'use strict';

  function toast(message) {
    var el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.hidden = false;
    clearTimeout(el._timer);
    el._timer = setTimeout(function () { el.hidden = true; }, 2500);
  }

  function updateCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () { /* silencioso */ });
  }

  function addToCart(variantId, quantity, title) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || 'No se pudo agregar el producto');
          return;
        }
        updateCartCount();
        toast('✓ ' + (title || 'Producto') + ' agregado al carrito');
      })
      .catch(function () { toast('Error de conexión. Intenta de nuevo.'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'AGREGANDO...';
    addToCart(id, 1, btn.getAttribute('data-product-title')).then(function () {
      btn.disabled = false;
      btn.textContent = original;
    });
  });

  /* Menú móvil */
  document.addEventListener('DOMContentLoaded', function () {
    var menu = document.querySelector('.mobile-menu');
    var panel = document.querySelector('.mobile-panel');
    if (menu && panel) {
      menu.addEventListener('click', function () { panel.classList.add('open'); });
      panel.addEventListener('click', function (e) {
        if (e.target.closest('[data-close]') || e.target.tagName === 'A') {
          panel.classList.remove('open');
        }
      });
    }
    updateCartCount();
  });


/* --- Página de producto: galería multimedia, cantidad y barra fija --- */
document.addEventListener('DOMContentLoaded', function () {
  /* Galería de imágenes y videos de Shopify */
  document.querySelectorAll('[data-pd-gallery]').forEach(function (gallery) {
    var items = gallery.querySelectorAll('[data-pd-media-item]');
    var thumbs = gallery.querySelectorAll('[data-pd-media-thumb]');

    function mostrarMedia(id) {
      items.forEach(function (item) {
        var activo = item.getAttribute('data-media-id') === id;

        item.hidden = !activo;
        item.classList.toggle('is-active', activo);

        if (!activo) {
          // Detener videos que quedan ocultos.
          item.querySelectorAll('video').forEach(function (video) {
            video.pause();
          });

          // Detener videos de YouTube/Vimeo si el iframe lo permite.
          item.querySelectorAll('iframe').forEach(function (frame) {
            var src = frame.getAttribute('src');
            if (src && /youtube|vimeo/i.test(src)) {
              frame.contentWindow.postMessage(
                JSON.stringify({
                  event: 'command',
                  func: 'pauseVideo',
                  method: 'pause'
                }),
                '*'
              );
            }
          });
        }
      });

      thumbs.forEach(function (thumb) {
        var activo = thumb.getAttribute('data-media-id') === id;

        thumb.classList.toggle('on', activo);
        thumb.classList.toggle('is-active', activo);
        thumb.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        if (id) mostrarMedia(id);
      });
    });

    // Asegurar que solo se muestre el primer elemento al iniciar.
    if (items.length) {
      var inicial = gallery.querySelector(
        '[data-pd-media-item].is-active'
      ) || items[0];

      mostrarMedia(inicial.getAttribute('data-media-id'));
    }
  });

  /* Compatibilidad con la galería antigua que usa #pdpMain */
  var oldMain = document.getElementById('pdpMain');

  if (oldMain) {
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (!full) return;

        oldMain.removeAttribute('srcset');
        oldMain.src = full;
        oldMain.alt = btn.getAttribute('data-alt') || '';

        document.querySelectorAll('[data-pdp-thumb]').forEach(function (b) {
          b.classList.remove('is-active');
        });

        btn.classList.add('is-active');
      });
    });
  }

  /* Cantidad del producto */
  var qty = document.getElementById('pdpQty');

  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qty) return;

      var change = parseInt(btn.getAttribute('data-qty'), 10) || 0;
      var current = parseInt(qty.value, 10) || 1;
      qty.value = Math.max(1, current + change);

      qty.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  if (qty) {
    qty.addEventListener('change', function () {
      var value = parseInt(qty.value, 10);
      qty.value = !value || value < 1 ? 1 : value;
    });
  }

  /* Barra fija de compra */
  var bar = document.querySelector('[data-buybar]');
  var addBtn = document.querySelector('.pdp-add, .pd-add');

  if (bar && addBtn) {
    var barAdd = bar.querySelector('[data-buybar-add]');

    if (barAdd) {
      barAdd.addEventListener('click', function () {
        var form = addBtn.closest('form');

        if (form) {
          if (form.requestSubmit) {
            form.requestSubmit(addBtn);
          } else {
            form.submit();
          }
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting;
        });
      }, { rootMargin: '0px 0px -40px 0px' });

      observer.observe(addBtn);
    }
  }
});


  /* Comparador antes/después */
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-before-after]')) {
      var wrap = e.target.closest('.before-after');
      if (wrap) wrap.style.setProperty('--split', e.target.value + '%');
    }
  });
})();
